import React, { useState, useEffect, useRef } from 'react';
import { InfoHeader, InfoWrapper, Close, Title } from './InfoStyled';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { ReactComponent as TitleSVG } from './assets/info_title.svg';
import { ReactComponent as CloseSVG } from './assets/info_close.svg';
import { EVENTS } from '../lib/constants';
import Main from './components/Main';
import HELPERS from '../lib/globals/helpers/Helpers';
import { useCallback } from 'react';
import { isDesktop } from 'react-device-detect';

export default function InfoPage({ configs, curr, currAbr }) {
	const [dimentions, setDimentions] = useState({
		width:
			GameConfigs.APP_WIDTH *
			Math.min(
				window.innerWidth / GameConfigs.APP_WIDTH,
				window.innerHeight / GameConfigs.APP_HEIGHT
			),
		height:
			GameConfigs.APP_HEIGHT *
			Math.min(
				window.innerWidth / GameConfigs.APP_WIDTH,
				window.innerHeight / GameConfigs.APP_HEIGHT
			),
		y:
			(window.innerHeight -
				GameConfigs.APP_HEIGHT *
					Math.min(
						window.innerWidth / GameConfigs.APP_WIDTH,
						window.innerHeight / GameConfigs.APP_HEIGHT
					)) /
			2,
		x:
			(window.innerWidth -
				GameConfigs.APP_WIDTH *
					Math.min(
						window.innerWidth / GameConfigs.APP_WIDTH,
						window.innerHeight / GameConfigs.APP_HEIGHT
					)) /
			2,
		scale: Math.min(
			window.innerWidth / GameConfigs.APP_WIDTH,
			window.innerHeight / GameConfigs.APP_HEIGHT
		)
	});
	const [coefs, setCoefs] = useState(configs);
	const [currency, setCurrency] = useState(curr);
	const [currentBet, setcurrentBet] = useState(GameConfigs.currentBet);
	const [fast, setFast] = useState(GameConfigs.settings.fast_spin);

	const containerRef = useRef(null);
	// const [clickable, setClickable] = useState(undefined)

	const handleResize = (e) => {
		let w = window.innerWidth;
		let h = window.innerHeight;
		let APP_WIDTH = GameConfigs.APP_WIDTH;
		let APP_HEIGHT = GameConfigs.APP_HEIGHT;

		let scale = Math.min(w / APP_WIDTH, h / APP_HEIGHT);
		let localW = APP_WIDTH * scale;
		let localH = APP_HEIGHT * scale;
		let localX = (w - localW) / 2;
		let localY = (h - localH) / 2;
		setDimentions({
			width: localW,
			height: localH,
			x: localX,
			y: localY,
			scale: scale
		});
	};

	const handleBetChange = useCallback((e) => {
		if (e.detail.betAmount) {
			setcurrentBet(e.detail.betAmount);
			// setClickable(false)
		}
	}, []);

	const handleReelFinished = (e) => {
		if (GameConfigs.win > 0) {
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		}
	};

	useEffect(() => {
		setCoefs(configs);
	}, [configs]);

	useEffect(() => {
		setCurrency(curr);
	}, [curr]);

	useEffect(() => {
		// Add the resize event listener
		window.addEventListener('resize', handleResize);
		window.addEventListener(EVENTS.BET_UPDATE, handleBetChange);
		window.addEventListener(EVENTS.REEL_FINISHED, handleReelFinished);
		window.addEventListener(EVENTS.SETTINGS_UPDATE, handleSettingsChanged);
		// Return the cleanup function
		return () => {
			// Remove the resize event listener
			window.removeEventListener('resize', handleResize);
			window.removeEventListener(EVENTS.BET_UPDATE, handleBetChange);
			window.removeEventListener(EVENTS.REEL_FINISHED, handleReelFinished);
			window.removeEventListener(EVENTS.SETTINGS_UPDATE, handleSettingsChanged);
		};
	}, [handleBetChange]);

	useEffect(() => {
		window.addEventListener('click', handleClickOutside);
		const infoElement = containerRef.current;
		if (infoElement) {
			infoElement.addEventListener('wheel', handleWheel, { passive: false });
			infoElement.addEventListener('touchmove', handleTouchMove, {
				passive: false
			});
		}
		return () => {
			window.removeEventListener('click', handleClickOutside);
			if (infoElement) {
				infoElement.removeEventListener('wheel', handleWheel);
				infoElement.removeEventListener('touchmove', handleTouchMove);
			}
		};
	}, []);

	const handleSettingsChanged = (event) => {
		if (event.detail.data.fast_spin === undefined) return;
		if (event.detail.data.fast_spin) {
			setFast(true);
		} else {
			setFast(false);
		}
	};

	const handleWheel = (event) => {
		if (event.ctrlKey) {
			event.preventDefault();
		}
	};
	const handleTouchMove = (event) => {
		if (event.touches.length > 1) {
			event.preventDefault();
		}
	};
	const handleClickOutside = (event) => {
		if (isDesktop) {
			if (window.restrictModalClose) {
				window.restrictModalClose = false;
				return;
			}

			if (
				containerRef.current &&
				!containerRef.current.contains(event.target) &&
				GameConfigs.modal === 'info'
			) {
				HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
			}
		}
	};

	const close = () => {
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
		GameConfigs.modal = '';
	};
	return (
		<InfoWrapper
			dimentions={dimentions}
			y={dimentions.y + dimentions.height * 0.23}
			ref={containerRef}
		>
			<InfoHeader dimentions={dimentions}>
				<Title dimentions={dimentions}>
					<TitleSVG />
				</Title>
				<Close onClick={() => close()}>
					<CloseSVG className='close-btn' />
				</Close>
			</InfoHeader>
			<Main
				dimentions={dimentions}
				currency={currency}
				currentBet={currentBet}
				coefs={coefs}
				currAbr={currAbr}
				fast={fast}
			/>
		</InfoWrapper>
	);
}
